var render = function render(){var _vm=this,_c=_vm._self._c;return _c('substance-allergies-template',{attrs:{"substance-allergies":_vm.substanceAllergies,"other-substance-allergies":_vm.otherSubstanceAllergies,"field-errors":_vm.fieldErrors},on:{"field-change":_vm.onFieldChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }